import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';
import TextAreaWithLabel from 'Components/UI/Overrides/TextAreaWithLabel';

const calendarEventFieldsToHide = [
  'createdAt',
  'updatedAt',
  'householdId',
  'eventId',
  'startTime',
  'endTime',
  'location',
  'meetingType',
  'eventType',
  'subject',
  'lastName',
  'priority',
  'bestNextStepId',
  'content',
  'bufferLength',
  'isCancelled',
  'title',
  'source',
  'isRescheduled',
  'rescheduleCount',
];

// eslint-disable-next-line import/prefer-default-export
export const ClientSchedulerCalendarEvent = fr.metaOverride()
  .nameOverride(calendarEventFieldsToHide, { hidden: true })
  .nameOverride('attendees', { _component: () => Autocomplete })
  .nameOverride('description', {
    _component: () => TextAreaWithLabel,
    _customProps: {
      size: 'sm',
      label: 'Meeting Notes (optional)',
      rowsMin: 3,
    },
    display: true,
    hidden: false,
  });
